var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-detail-component" },
    [
      _c("div", { staticClass: "detail-section basic-info" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("交易订单号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.outTradeNo || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单状态："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.statusName || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("交易发起时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.payStartTime || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("交易完成时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.payEndTime || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("下单用户："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm.orderDetail.userName || "--") +
                          "[" +
                          _vm._s(_vm.orderDetail.uid) +
                          "]"
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("成交小程序："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.appName || "--")),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-section trade-info" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单金额："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value amount" }, [
                        _vm._v("¥ " + _vm._s(_vm.orderDetail.totalFee || "--")),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "amount-detail" }, [
                        _vm._v(
                          "\n              (福豆: ¥ " +
                            _vm._s(_vm.orderDetail.useIntegral || "--") +
                            ", 微信: ¥ " +
                            _vm._s(_vm.orderDetail.paidPrice || "--") +
                            ")\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "view-fudou-btn",
                          attrs: {
                            type: "text",
                            size: "mini",
                            icon: "el-icon-view",
                          },
                          on: { click: _vm.showFudouDetail },
                        },
                        [_vm._v("\n              查看福豆\n            ")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("优惠券优惠："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value discount" }, [
                        _vm._v(
                          " ¥ " + _vm._s(_vm.orderDetail.couponPrice || "0")
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.orderDetail.couponPrice &&
                      _vm.orderDetail.couponPrice !== "0"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "view-coupon-btn",
                              attrs: {
                                type: "text",
                                size: "mini",
                                icon: "el-icon-view",
                              },
                              on: { click: _vm.showCouponDetail },
                            },
                            [_vm._v("\n              查看优惠\n            ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-section third-party-info" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("商品名称："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.productName || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单状态："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.statusName || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("方案名称："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.marketingName || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("商品描述："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm.orderDetail.productDescription || "--")
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("水表号：")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.waterMeterCode || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("下单状态："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.statusName || "--")),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-section refund-info" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("退款类型："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.refundStatusName || "--")),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("退款金额："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value refund-amount" }, [
                      _vm._v(
                        "¥ " + _vm._s(_vm.orderDetail.refundAmount || "--")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "refund-detail" }, [
                      _vm._v(
                        "\n              (福豆: ¥ " +
                          _vm._s(_vm.orderDetail.refundUseIntegral || "--") +
                          ", 微信: ¥ " +
                          _vm._s(_vm.orderDetail.refundPaidAmount || "--") +
                          ")\n            "
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-section operation-log" }, [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-content" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.orderDetail.logList || [],
                  "element-loading-text": "加载中...",
                  "element-loading-spinner": "el-icon-loading",
                  stripe: "",
                  border: "",
                  "default-sort": {
                    prop: "operationTime",
                    order: "descending",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "时间",
                    width: "180",
                    sortable: "",
                    formatter: _vm.formatDateTime,
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "operator",
                    label: "操作人",
                    width: "120",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "description",
                    label: "日志明细",
                    "min-width": "200",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "requestParam",
                    label: "请求参数",
                    "min-width": "200",
                    "show-overflow-tooltip": "",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "fudou-detail-dialog",
          attrs: {
            title: "福豆使用详情",
            visible: _vm.fudouDetailVisible,
            width: "80%",
            "close-on-click-modal": false,
            "close-on-press-escape": true,
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.fudouDetailVisible = $event
            },
          },
        },
        [
          _vm.fudouDetailVisible
            ? _c("FudouDetailComponent", {
                attrs: {
                  orderId: _vm.orderDetail.outTradeNo || "",
                  visible: _vm.fudouDetailVisible,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.fudouDetailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "coupon-detail-dialog",
          attrs: {
            title: "优惠详情",
            visible: _vm.couponDetailVisible,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": true,
            modal: false,
            "before-close": _vm.handleCouponDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.couponDetailVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "coupon-detail-content" }, [
            _c("div", { staticClass: "coupon-info-item" }, [
              _c("span", { staticClass: "info-label" }, [
                _vm._v("优惠券名称："),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.orderDetail.couponName || "--")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "coupon-info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("优惠金额：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value amount" }, [
                _vm._v(_vm._s(_vm.orderDetail.couponPrice || "0") + " 元"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.couponDetailVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("基础信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("交易信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("第三方订单信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("退款信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("操作日志列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }